import { z } from 'zod'

/**
 * Mat Bot's URL state — the query lives in the URL for the same reasons the
 * Library's filters do: the topbar search on every page lands here carrying
 * `?q`, and a search somebody ran is shareable and survives a refresh.
 *
 * `.catch()` because search params are user-editable; a mangled `q` falls
 * back to the landing state rather than throwing a route error.
 */
export const searchSearchSchema = z.object({
  q: z.string().max(200).optional().catch(undefined),
})
